export default "__VITE_ASSET__CaC90yJM__"